<template>
    <div class="modal">
        <v-dialog
                v-model="dialog"
                :width="width"
                persistent
        >
        <v-card>
            <v-card-title
                    v-show="title!=''"
                    class="subheading secondary white--text" secondary-title>
                {{title}}
            </v-card-title>

            <v-card-text>
               <slot></slot>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        v-if="cancelMessage != ''"
                        color="secondary"
                        flat
                        @click="$emit('hide')"
                        class="text-capitalize"
                >
                    <i class="material-icons">
                    close
                    </i>
                    {{cancelMessage}}
                </v-btn>
                <v-btn
                        v-if="confirmMessage != ''"
                        color="secondary"
                        flat
                        @click="$emit('actionConfirm')"
                        class="text-capitalize"
                >
                    <i class="material-icons">
                        check
                    </i> {{confirmMessage}}
                </v-btn>
            </v-card-actions>
        </v-card>

        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props : {
            dialog : false,
            title : {
               type : String,
               default : ''
            },
            cancelMessage : {
                type : String,
                default : ''
            },
            confirmMessage :{
                type : String,
                default : ""
            },
            width:{
                type : Number,
                default : 500,
            }
        },
        methods : {
            hide(){
                this.$emit('hide');
            }
        }
    }
</script>

<style scoped>

</style>